import { Injectable } from "@angular/core";
import { Component, Input, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-confirmation-message',
	templateUrl: './confirmation-message.component.html',
	providers: [NgbModalConfig, NgbModal]
})

    @Injectable()
export class ConfirmationMessageComponent {
	@Output() confirmationClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onHide: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() title: string;
	@Input() message: string;
    @ViewChild('contentConfirmation', { static: false }) contentConfirmation: ElementRef;

	constructor(config: NgbModalConfig, private modalService: NgbModal) {
		config.backdrop = 'static';
		config.keyboard = false;
	}

	public showMessage(): void {
		this.modalService.open(this.contentConfirmation);
	}

	confirmation(): void {
		this.confirmationClicked.emit(true);
	}
}
